import { environment } from "../../../environments/environment";

const BASE_URL = `${environment.BASE_URL}/api/v1`;

export const ROUTES = {
  LOGIN: `${BASE_URL}/auth/signin`,
  INITIATE_PAYMENT: `${BASE_URL}/payment/initiate`,
  VERIFY_PAYMENT: `${BASE_URL}/payment/verify/ui/{gateway}`,
  GET_LAST_TRAN_BY_FC: `${BASE_URL}/members/transactions`,
  GET_MEMBER_DETAILS: `${BASE_URL}/members`,
  GET_PHIL_DEPOSIT_CODES: `${BASE_URL}/phil-meta-data/deposit-codes`,
  GET_WORKER_BY_KEY: `${BASE_URL}/worker/all`,
  GET_BENIFICIARY_BY_KEY: `${BASE_URL}/worker/beneficiary/all`,
  CREATE_ENTRY: `${BASE_URL}/entries`,
  GET_OBJECT_SPECIFICATION: `${BASE_URL}/phil-meta-data/object/specifications`,
  MEMBER_DETAILS_UPDATE: `${BASE_URL}/members/update/details`,
  GET_ALL_MAGAZINES: `${BASE_URL}/magazine`,
  GET_ALL_SUBSCRIPTIONS: `${BASE_URL}/magazine/subcription/types`,
  GET_DELIVERY_MODES: `${BASE_URL}/magazine/delivery/modes`,
  DISCOUNT_OPTION: `${BASE_URL}/magazine/discount/info`,
  MAGAZINE_TRANS_DETAILS: `${BASE_URL}/magazine/last-order-details`,
  SAVE_MAGAZINE: `${BASE_URL}/magazine/order/new`,
  GET_MAGAZINE_TRANSACTION: `${BASE_URL}/magazine/subcription/details`,
  GET_MAGAZINE_ORDER_STATISTICS: `${BASE_URL}/magazine/order/statistics`,
  GET_BY_PINCODE: `${BASE_URL}/geo-data/pincodes/{pin}`,
  GET_ALL_STATES: `${BASE_URL}/geo-data/states`,
  GET_ALL_DISTRICTS_BY_STATE: `${BASE_URL}/geo-data/{state}/districts`,
  GET_ADDR_BY_KEY: `${BASE_URL}/geo-data/addresses/{addr}`,
  GET_ALL_BANKS: `${BASE_URL}/phil-meta-data/bank-accounts`,
  GET_DEPOSIT_HISTORY: `${BASE_URL}/members/transactions`,
  GET_OCCURENCE_DETAILS: `${BASE_URL}/entries/details`,
  GET_ENTRY_DETAILS: `${BASE_URL}/entries`,
  UPDATE_MEMBER: `${BASE_URL}/members/update/details`,
  PRINT_MAGAZINE_RECEIPT_DATA: `${BASE_URL}/magazine/print-order-details`,
  PAYMENT_TIMING: `${BASE_URL}/phil-meta-data/centers/timing`,
  GET_ALL_ENTRY_DETAILS: `${BASE_URL}/entries/all`,
  REFRESH_PAYMENT: `${BASE_URL}/payment/refresh`,
  USER_INFO: `${BASE_URL}/members/user/info`,
  UPDATE_USER_CONTACT: `${BASE_URL}/members/change/user/contact`,
  MAGAZINE_TIMING: `${BASE_URL}/phil-meta-data/magazine/timing`,
  VERIFY_ORDER: `${BASE_URL}/payment/verify/order`,
  ORDER_REFRESH_PAYMENT: `${BASE_URL}/payment/order-refresh`,
  TAX_CLAIM: `${BASE_URL}/phil-meta-data/tax-claim`,
  TAX_CLAIMED_DETAILS: `${BASE_URL}/phil-meta-data/tax-claimed-details`,
  TAX_DOWNLOAD: `${BASE_URL}/members/tax/download`
};